// dashboard\src\pages\Settings\index.tsx
import React from 'react'
import {useSettingsController} from './SettingsController'
import {SettingsView} from './SettingsView'

const SettingsPage: React.FC = () => {
    const controller = useSettingsController()
    return <SettingsView {...controller} />
}

export default SettingsPage